import color from './color.js'
import sizes from './sizes.js'
import shadow from './shadow.js'
import theme from './theme.js'
import animation from './animation.js'
import media from './media.js'
// The workspace GLYPH set (px* pixel, ln* line) — GENERATED by scripts/gen-glyph-icons.mjs. It merges into
// the shell beside the brand icons (shared libraries merge the design system key by key — deepDefaults), and
// every name is prefixed, so no brand icon is replaced.
import icons from './icons.js'

// `timing` is gone: its one staged key, `springBezier`, ships in brand since
// 3.14.798 (lane D1 of the white-label redesign) — brand designSystem/timing.js.
export default {
  color,
  sizes,
  shadow,
  theme,
  animation,
  media,
  icons
}
